export const CONVERSATION_SCOPE = {
  ALL: 'all',
  OWNED: 'owned',
} as const;

// Only 'owned' is URL-storable; 'all' is UI-only and normalizes to undefined in updateUrlParams
export type ConversationScope = typeof CONVERSATION_SCOPE.OWNED;

export interface ConversationalAIParams {
  conversationId?: string;
  scope?: ConversationScope;
}
